import React, { createContext, useContext, useState, useCallback } from "react";
import { ToastContainer } from "../components/ui/Toast";

const ToastContext = createContext(null);

/**
 * Global toast provider. Mount once (e.g. in AppLayout).
 * Use via: const toast = useToast(); toast.success("Saved"); toast.error("Failed");
 */
export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback(
    (message, variant = "info", title, duration = 4000) => {
      const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      setToasts((prev) => [...prev, { id, message, variant, title, duration }]);
    },
    []
  );

  const toast = {
    success: (message, title = "Success") =>
      addToast(message, "success", title),
    error: (message, title = "Error") => addToast(message, "danger", title),
    info: (message, title) => addToast(message, "info", title),
    warning: (message, title) => addToast(message, "warning", title),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <ToastContainer toasts={toasts} onClose={removeToast} />
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return ctx;
}
